export const messages = {
  title: { id: 'admin/promotions.form.budget.editor.title' },
  subtitle: { id: 'admin/promotions.form.budget.editor.subtitle' },
  moreInformation: {
    id: 'admin/promotions.links.restrictions.budget.more-information',
  },
  label: {
    id: 'admin/promotions.form.budget.editor.input.label',
  },
  helpText: {
    id: 'admin/promotions.form.budget.editor.input.help-text',
  },
  autoStopAlert: {
    id: 'admin/promotions.form.budget.editor.alert',
  },
  validation: {
    required: {
      id: 'admin/promotions.form.validation.required',
    },
    greaterThan: {
      id: 'admin/promotions.form.validation.greater-than',
    },
    notificationThresholdRequired: {
      id: 'admin/promotions.form.budget.editor.notification.validation.threshold-required',
    },
    emailInvalidMultiple: {
      id: 'admin/promotions.form.budget.editor.notification.email-invalid-multiple',
    },
  },
}
